export default __webpack_public_path__ + "static/media/70t.29e75bda.jpg";